
import { tr } from '../translate'
import Check from '@/assets/icons/support_ticket/check.svg?inline'
import ExternalLink from '@/assets/icons/support_ticket/external-link.svg?inline'

export default {
  components: { Check, ExternalLink },
  props: {
    config: {
      type: Object,
      default: null,
    },
    category: {
      type: Object,
      default: null,
    },
    subcategory: {
      type: Object,
      default: null,
    },
    ticket: {
      type: String,
      default: '',
    },
    orderNum: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    fileName: {
      type: String,
      default: '',
    },
  },
  computed: {
    ui() {
      return this.config?.ui
    },
    rows() {
      return [
        {
          label: this.tr(this.ui?.labels?.category),
          value: this.tr(this.category?.translations)?.label,
        },
        this.subcategory && {
          label: this.tr(this.ui?.labels?.subcategory),
          value: this.tr(this.subcategory?.translations)?.label,
        },
        this.orderNum && {
          label: this.tr(this.ui?.labels?.order_number),
          value: this.orderNum,
        },
      ].filter(Boolean)
    },
  },
  methods: {
    tr(entry) {
      return tr(entry, this.$i18n.locale)
    },
  },
}
